import useQuery from '../../../utils/hooks/useQuery';
import { useEffect } from 'react';
// import { useGetBalance } from '../../../lib/cryptoys/payments/balances';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styles from './Start.module.css';
import { Button } from '@onchainstudios/cryptoys-common-ui';
import QuantitySelector from '../../../components/QuantitySelector';
import Header from '../../../components/Header';
import Footer from '../../../components/Footer';
import PaymentSteps from '../../../components/PaymentSteps';
import ErrorMessageBlock from '../../../components/ErrorMessageBlock';
import TermsConditions from '../../../components/TermsConditions/TermsConditions';

import {
  // formatCurrencyUSD,
  getNumCubes,
  redirectToCryptoysDrops,
  setLocalStorageDropStatus
} from '../../../utils';

function Start({
  // recaptchaToken,
  reservationId,
  correlationId,
  dropData,
  reservationData
}) {
  const query = useQuery();
  const dropId = query.get('dropId');
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const numCubes = parseInt(searchParams.get('numCubes') ?? 1);
  const purchaseQuantity = reservationData
    ? reservationData.data.products?.length
      ? reservationData.data.products[0].quantity
      : reservationData.data.purchaseQuantity
    : null; // This is backwards compatible with old purchaseQuantity field

  // const {
  //   data: balanceData,
  //   isLoading: isBalanceLoading,
  //   isError: isBalanceError
  // } = useGetBalance({ didToken, recaptchaToken });

  useEffect(() => {
    if (reservationId && correlationId && reservationData) {
      searchParams.set('reservationId', reservationId);
      searchParams.set('correlationId', correlationId);
      searchParams.set('numCubes', getNumCubes(numCubes, purchaseQuantity));
      setSearchParams(searchParams.toString(), { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reservationId, correlationId, reservationData]);

  useEffect(() => {
    if (dropData) {
      if (dropData.data?.inventoryStatus !== 'AVAILABLE') {
        // Set local storage for Cryptoys legacy app to consume
        setLocalStorageDropStatus(
          dropId,
          dropData.data.status,
          dropData.data.inventoryStatus
        );
        redirectToCryptoysDrops();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dropData]);

  useEffect(
    () => {
      document.title = 'Cryptoys - Choose Payment Method';
      window.scrollTo(0, 0);
      // if (isBalanceLoading) {
      //   return;
      // }
    },
    [
      /* isBalanceLoading */
    ]
  );

  // if (isBalanceLoading) {
  //   return <Loading />;
  // }

  if (dropData && reservationData /** && (balanceData || isBalanceError) **/) {
    const handleNumCubeChange = (type) => {
      if (type === 'increment') {
        const incrementedCubeValue = numCubes + 1;
        if (incrementedCubeValue <= purchaseQuantity) {
          searchParams.set('numCubes', incrementedCubeValue);
          setSearchParams(searchParams.toString(), { replace: true });
        }
      }
      if (type === 'decrement') {
        const decrementedCubeValue = numCubes - 1;
        if (decrementedCubeValue >= 1) {
          searchParams.set('numCubes', decrementedCubeValue);
          setSearchParams(searchParams.toString(), { replace: true });
        }
      }
      if (type === 'max') {
        searchParams.set('numCubes', purchaseQuantity);
        setSearchParams(searchParams.toString(), { replace: true });
      }
    };
    const handleNavigate = (route) => {
      searchParams.delete('error');
      navigate({
        pathname: route,
        search: '?' + searchParams
      });
    };
    const currentPrice = numCubes * parseFloat(dropData.data.price);
    const isCryptoDisabled = true;
    // const isCryptoBalanceSufficient =
    //   balanceData?.data?.totalInUsd >= currentPrice;
    // const isCryptoDisabled = isBalanceError || !isCryptoBalanceSufficient;

    return (
      <>
        <div className="container">
          <Header reservationId={reservationId} />
          <main className="mainContainer">
            <PaymentSteps />
            <section
              id="mainContent"
              className={`contentContainer ${styles.container}`}
            >
              <h1 className="heading2 spanGrid">Select Quantity</h1>
              <p className="spanGrid">
                Select how many you would like to purchase to get started.
              </p>
              {!!searchParams.get('error') && (
                <ErrorMessageBlock
                  message={decodeURIComponent(searchParams.get('error'))}
                />
              )}
              <div className={styles.contentContainer}>
                <div className={styles.chooseAmount}>
                  <QuantitySelector
                    onClickUp={() => handleNumCubeChange('increment')}
                    onClickDown={() => handleNumCubeChange('decrement')}
                    setMaxCubes={() => handleNumCubeChange('max')}
                    numCubes={numCubes}
                    limitedInventory={
                      dropData.data.purchaseLimit > purchaseQuantity
                    }
                    currentPrice={currentPrice}
                    maxNumCubes={numCubes === purchaseQuantity}
                    horizontal={true}
                    headline={dropData.data.headline}
                    subHeadline={dropData.data.subHeadline}
                  />
                </div>
                <div className={`${styles.subheading} spanGrid`}>
                  <h2 className="heading2 spanGrid">Choose Payment Method</h2>
                  <p className="spanGrid">
                    Take a look at your order details and let us know your
                    preferred method of payment
                  </p>
                </div>
                <div
                  id="crypto-balance-section"
                  data-testid="crypto-balance-section"
                  className={`${styles.accountBalance} borderMask ${
                    isCryptoDisabled ? styles.isDisabled : ''
                  }`}
                >
                  <h2 className={`${styles.chooseHeaderText} display4`}>
                    Account Balance
                  </h2>
                  <p className="bodySmReg">
                    Pay using a currency in your account balance
                  </p>
                  <span className={styles.totalBalance}>
                    Total Balance: $0.00
                    {/* {balanceData
                      ? 'Total Balance: ' +
                        formatCurrencyUSD(balanceData.data.totalInUsd)
                      : 'There was a problem fetching your balances'} */}
                  </span>
                  <span className={styles.buttonContainer}>
                    <Button
                      data-testid="crypto-balance-section-button"
                      fullWidth={true}
                      size={'large'}
                      isDisabled={isCryptoDisabled}
                      buttonColor={'red'}
                      onPress={() => {
                        if (!isCryptoDisabled) {
                          handleNavigate('#');
                          // handleNavigate('/select-currency');
                        }
                      }}
                    >
                      Pay With Account Balance
                    </Button>
                  </span>
                </div>
                <div
                  id="credit-card-section"
                  data-testid="credit-card-section"
                  className={`${styles.creditCard} borderMask`}
                >
                  <h2 className={`${styles.chooseHeaderText} display4`}>
                    Credit Card
                  </h2>
                  <p className="bodySmReg">
                    Pay using your credit card information
                  </p>
                  <span className={styles.totalBalance}>
                    Only Available in USA
                  </span>
                  <span className={styles.buttonContainer}>
                    <Button
                      data-testid="credit-card-section-button"
                      fullWidth={true}
                      size={'large'}
                      onPress={() => {
                        searchParams.set('isCreditCardPurchase', true);
                        searchParams.set('purchaseCurrency1', 'USD');
                        handleNavigate('/confirm');
                      }}
                    >
                      Pay With Credit Card
                    </Button>
                  </span>
                </div>
              </div>
            </section>
          </main>
          <TermsConditions />
          <Footer />
        </div>
      </>
    );
  }
  return <></>;
}

export default Start;
